// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumption-dashboard-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.consumption-dashboard-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.consumption-dashboard-page .page-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.consumption-dashboard-page .error-message {
  background: #fee;
  color: #c00;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

/* Stats Grid */
.consumption-dashboard-page .stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Charts Grid */
.consumption-dashboard-page .charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.consumption-dashboard-page .charts-grid-full {
  grid-template-columns: 1fr;
}

/* Consumption Table */
.consumption-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  overflow-x: auto;
}

.consumption-table-container h2 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #333;
}

.consumption-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.consumption-table th,
.consumption-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.consumption-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #555;
  font-size: 0.85rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.consumption-table .clickable-row {
  cursor: pointer;
  transition: background 0.2s;
}

.consumption-table .clickable-row:hover {
  background: #f0f7ff;
}

.consumption-table .account-name {
  font-weight: 500;
  color: var(--button-color, #007bff);
}

.consumption-table .empty-message {
  text-align: center;
  color: #888;
  padding: 2rem;
}

/* Responsive */
@media (max-width: 768px) {
  .consumption-dashboard-page {
    padding: 1rem;
  }

  .consumption-dashboard-page .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .consumption-dashboard-page .charts-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ConsumptionDashboardPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".consumption-dashboard-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.consumption-dashboard-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.consumption-dashboard-page .page-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.consumption-dashboard-page .error-message {\n  background: #fee;\n  color: #c00;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n/* Stats Grid */\n.consumption-dashboard-page .stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n/* Charts Grid */\n.consumption-dashboard-page .charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.consumption-dashboard-page .charts-grid-full {\n  grid-template-columns: 1fr;\n}\n\n/* Consumption Table */\n.consumption-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  overflow-x: auto;\n}\n\n.consumption-table-container h2 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.consumption-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.consumption-table th,\n.consumption-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.consumption-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #555;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.consumption-table .clickable-row {\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.consumption-table .clickable-row:hover {\n  background: #f0f7ff;\n}\n\n.consumption-table .account-name {\n  font-weight: 500;\n  color: var(--button-color, #007bff);\n}\n\n.consumption-table .empty-message {\n  text-align: center;\n  color: #888;\n  padding: 2rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .consumption-dashboard-page {\n    padding: 1rem;\n  }\n\n  .consumption-dashboard-page .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .consumption-dashboard-page .charts-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
